import moment from "moment";
import { atom } from "recoil";
// import c from '../../data/curriculum.json';

export const lectureItemState = atom({
  key: "lecture/item/id",
  default: null,
});
export const lectureTitleState = atom({
  key: "lecture/item/title",
  default: "",
});
export const lectureDateState = atom({
  key: "lecture/item/date",
  default: [
    { date: moment().format("YYYY-MM-DD"), hour: 9, minute: 0 },
    { date: moment().format("YYYY-MM-DD"), hour: 10, minute: 0 },
  ],
});
export const lecturePlaceState = atom({
  key: "lecture/item/place",
  default: "",
});
export const lectureHostState = atom({
  key: "lecture/item/host",
  default: "",
});
export const lectureInfoState = atom({
  key: "lecture/item/info",
  default: [],
});
export const lectureCurriculumState = atom({
  key: "lecture/item/curriculum",
  default: [],
});
export const lectureReportState = atom({
  key: "lecture/item/report",
  default: [],
});

export const lectureListState = atom({
  key: "lecture/list",
  default: [],
});
